import $ from 'jquery';
require('../plugins/appendAround');

const $el = {
	appendAround: $('.js-append-around')
};

function init() {
	initAppendAround();
}

function initAppendAround() {
	if (!$el.appendAround.length) return;

	$el.appendAround.each(function() {
		$(this).appendAround();
	});
}

export default init;